// import CopyrightFooter from "@/components/common/footer/CopyrightFooter";
import Footer from "@/components/common/footer/Footer";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import EditCifMain from "../user/MyBids/Editcif/EditCif";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const EditCif = () => {
  return (
    <>
      {/* header */}
      <Header />
      <MobileMenu />
      <PopupSignInUp />

      <EditCifMain />
      {/* footer */}
      {/* <section className="bg-ptrn2 footer_one home6">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>
      <section className="footer_middle_area home6 pb30 pt30">
        <div className="container">{/* <CopyrightFooter /> */}</div>
      </section>
    </>
  );
};

export default EditCif;
